import values from 'lodash/values'
import { ROLE } from '@utils/constant'
import formatDate from '@utils/format-date'

export const ROLE_AGENT = [ROLE.AGENT_ADMIN, ROLE.AGENT_SUB, ROLE.AGENT_AUDIT]

export const FULL_ROLE_AGENT = [
  ROLE.AGENT_ADMIN,
  ROLE.AGENT_SUB,
  ROLE.AGENT_AUDIT,
  ROLE.AGENT_ANNOUNCE,
]

export const FULL_ROLE_AGENT_EDIT = [
  ROLE.AGENT_ADMIN,
  ROLE.AGENT_SUB,
  ROLE.AGENT_ANNOUNCE,
]

export const FULL_ROLE = values(ROLE) // all role

const ObjectHelper = {
  /**
   * example test = { id: 100, name: 'test', password: '1234' }
   * removePropertyByKey('name')(test) remove property name
   * removePropertyByKey('id')(test) remove property id
   */
  removePropertyByKey: (prop) => ({ [prop]: _, ...rest }) => rest,
}

export { ObjectHelper }

export function csvExport(data, fileName) {
  const today = new Date()
  const filename = `${fileName}${formatDate(today, 'yyyyMMdd')}.csv`
  if (window.navigator.msSaveOrOpenBlob) {
    // if browser is IE
    const blob = new Blob([decodeURIComponent(encodeURI(data))], {
      type: 'text/csv;charset=utf-8;',
    })
    navigator.msSaveBlob(blob, filename)
  } else {
    const blob = new Blob([data], { type: 'text/csv' })
    const link = document.createElement('a')

    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
    window.URL.revokeObjectURL(link.href)
  }
}

export function addParamsToLocation(route, params) {
  history.replaceState(
    {},
    null,
    route.path +
      '?' +
      Object.keys(params)
        .map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        })
        .join('&')
  )
}
